import React from 'react';
import { Field } from 'react-final-form';
import { FormControlLabel as MuiFormControlLabel, Checkbox as MuiCheckbox } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as CircleIcon
} from '@mui/icons-material';

const FormCheckBox = ({
  name,
  value,
  label,
  onChange,
  defaultValue,
  checkedIcon,
  icon,
  disabled = false,
  readOnly = false,
  dataId = 'form-check-box',
  className,
  ...props
}) => {
  return (
    <Field
      defaultValue={defaultValue}
      name={name}
      value={value}
    >
      {({ input, meta }) => (
        <MuiFormControlLabel
          label={label}
          data-id={dataId}
          control={
            <MuiCheckbox
              checked={value || !!input.value}
              disabled={disabled}
              onClick={(e, value) => {
                if (readOnly) {
                  return
                }

                input.onChange(e.target.checked)
                onChange && onChange(e.target.checked)
              }}
              checkedIcon={checkedIcon || <CheckCircleIcon />}
              icon={icon || <CircleIcon />}
              className={className}
            />
          }
        />
      )}
    </Field>
  );
};

export default FormCheckBox;
